module.exports = __webpack_public_path__ + "img/27_90.68b94295.png";